import { createIcon } from './icon-utils';

export const GreenTickIcon = createIcon({
  fill: '#40C37B',
  path: 'M7.16563 13.5002L2.89062 9.2252L3.95938 8.15645L7.16563 11.3627L14.0469 4.48145L15.1156 5.5502L7.16563 13.5002Z',
  style: { height: 18, width: 18 },
  viewBox: '0 0 18 18',
});
